import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';
import { logCoreUsage as logCoreUsageWithMailbox } from 'owa-analytics';
import type { CustomData, DatapointOptions } from 'owa-analytics-types';

export function logCoreUsage(
    eventName: string,
    customData?: CustomData,
    options?: DatapointOptions
): Promise<void> {
    return logCoreUsageWithMailbox(eventName, getUserMailboxInfo(), customData, options);
}
